import { useCallback, useEffect, useState } from 'react'

import { axiosInstance } from '../../../../../hooks/useAxios'
import { IListUnlinkedSkusResult, IUnlinkedSku } from '../types'

interface Params {
  enabled: boolean // ดึงเฉพาะตอนเปิดดูที่ยังไม่มีต้นทุน
  startDate?: string
  endDate?: string
  shopId?: string
  reloadKey?: number // เปลี่ยนค่า = บังคับโหลดใหม่ (เช่น หลัง backfill เสร็จ)
}

// SKU ที่ยังไม่ผูกกับสินค้าในระบบ สรุปจากคำสั่งซื้อที่ต้นทุนไม่ครบในช่วงที่เลือก
export const useUnlinkedSkus = ({
  enabled,
  startDate,
  endDate,
  shopId,
  reloadKey,
}: Params) => {
  const [items, setItems] = useState<IUnlinkedSku[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)

  const fetchItems = useCallback(
    async () => {
      setIsLoading(true)
      setError(false)
      try {
        const res = await axiosInstance.get<IListUnlinkedSkusResult>(
          '/tiktok/report/orders/unlinked-skus',
          {
            params: {
              ...(startDate ? { startDate } : {}),
              ...(endDate ? { endDate } : {}),
              ...(shopId ? { shopId } : {}),
            },
          },
        )
        setItems(res.data.items)
      } catch {
        setError(true)
      } finally {
        setIsLoading(false)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [startDate, endDate, shopId, reloadKey],
  )

  useEffect(() => {
    if (!enabled) {
      return
    }
    setItems([])
    fetchItems()
  }, [enabled, fetchItems])

  return { items, isLoading, error }
}
